import React, { useCallback, useEffect, useReducer, useState } from "react"
import { obterSelosPremiados } from "../../../services/seloPremiadoFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { SeloPremiadoFornecedorInicial } from "../models/seloPremiadoFornecedorModel"
import { SeloPremiadoFornecedorActionsTypes } from "./seloPremiadoFornecedorActions"
import { SeloPremiadoFornecedorContext } from "./SeloPremiadoFornecedorContext"
import { seloPremiadoFornecedorReducer } from "./seloPremiadoFornecedorReducer"

export function SeloPremiadoFornecedorContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(
        seloPremiadoFornecedorReducer,
        SeloPremiadoFornecedorInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const recarregar = useCallback(
        async (busca?: string) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            try {
                setLoading(true)
                const response = await obterSelosPremiados(autorizacao, busca)
                if ("retornoErro" in response) {
                    setErroCarregamento(response.mensagem || "Erro ao carregar selos premiados")
                } else {
                    setErroCarregamento(null)
                    dispatch({
                        type: SeloPremiadoFornecedorActionsTypes.CARREGAR,
                        payload: response,
                    })
                }
            } catch {
                setErroCarregamento("Erro ao carregar selos premiados")
            } finally {
                setLoading(false)
            }
        },
        [setLoading]
    )

    useEffect(() => {
        recarregar()
    }, [recarregar])

    return (
        <SeloPremiadoFornecedorContext.Provider
            value={{ dados, dispatch, erroCarregamento, recarregar }}
        >
            <Loading />
            {children}
        </SeloPremiadoFornecedorContext.Provider>
    )
}
